const state = {
  httpState: "1"
};

const mutations = {
  SET_STATE(state, num) {
    state.httpState = num;
  }
};
const actions = {
  sethttp({ commit }, index) {
    commit("SET_STATE", index);
  }
};
export default {
  state,
  mutations,
  actions
};
